import React, { useEffect } from 'react'
import { Navbar } from '../../components';
import { Footer } from '../../containers';
import './terms.css'

import BGHeader from '../../assets/bg-header.png';

function Terms() {
  useEffect(() => {
    document.title = "Terms and Conditions - Greymate Care";
  }, []);
  return (
    <>
    <div className='gmc__privacy-background'>
      <Navbar/>
      <div className='gmc__contact-us__header section__padding section__bg__lines'  style={{ 
        backgroundImage: `url(${BGHeader})` 
      }}>
        <h1 className='section__heading'>Terms and Conditions</h1>
      </div>
    </div>
    <Footer/>
    </>
  )
}

export default Terms